import {
  Grid,
  TextField,
  Radio,
  Typography,
  makeStyles,
  Dialog,
  DialogContent,
  createTheme,
  ThemeProvider,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import _isEmpty from 'lodash/isEmpty';
import CloseIcon from '@material-ui/icons/Close';
import ZeroState from '../common/ZeroState';
import FileSeachIcon from '../../assets/FileSearchIcon';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ErrorToast, formatTime, generateVideoUrl } from '../utils/Utils';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import Image from '../common/Image';
import VideoPlayIcon from '../../assets/VideoPlayIcon';
import { CustomReactPlayer } from '../common/ReactPlayer';

const useStyle = makeStyles({
  searchInput: {
    width: '90%',
    padding: '10px',
    background: '#fff',
    borderRadius: '10px',
  },
  journeyContainer: {
    width: '92%',
    height: '55vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  jouney: {
    background: '#fff',
    padding: '10px',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  titleBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
    padding: '2px',
  },
  guides: {
    width: '95%',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '20px',
    marginTop: '10px',
  },
  guide: {
    width: '47%',
    height: '100px',
    border: '1px solid #E4E7EC',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
  },
  profilePic: {
    height: '100%',
    width: '22%',
    borderRadius: '5px',
    overflow: 'hidden',
    cursor: 'pointer',
    position: 'relative',
  },
  videoIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  content: {
    height: '100%',
    width: '78%',
    padding: '0px 10px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#10182B',
  },
  duration: {
    marginTop: '10px',
    fontSize: '13px',
    fontWeight: '500',
    color: '#667085',
  },
  closeIcon: {
    cursor: 'pointer',
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'rgba(0,0,0,0.4)',
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const customTheme = createTheme({
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(0,0,0,0.6)',
      },
    },
  },
});

export default function GuideList({ slectedGuide, setSelectedGuide, slectedJ, setSelectedJ, callFrom, dealershipId }) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const delaershipHeader = useSelector((state) => state.DealershipDetails.dealershipdetails);

  const [journeys, setJourneys] = useState([]);
  const [openedJouenys, setOpenedJourneys] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [filteredJourneys, setFilteredJourneys] = useState([]);
  const [isOpenVideoPreview, setIsOpenVideoPreview] = useState(false);
  const [guideUrl, setGuideUrl] = useState('');
  const [dealerId, setDealerId] = useState(null);

  useEffect(() => {
    if (dealerId) {
      getGuides();
    }
  }, [dealerId]);

  useState(() => {
    if (callFrom === 'px') {
      setDealerId(dealershipId);
    } else {
      setDealerId(delaershipHeader.id);
    }
  }, [delaershipHeader]);

  useEffect(() => {
    setFilteredJourneys(journeys);
  }, [journeys]);

  const getGuides = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.DEALER_GUIDE_LIST.replace('ID', dealerId));
      setJourneys(res);
      if (res?.length > 0 && _isEmpty(slectedJ)) {
        setOpenedJourneys([res[0]?.journeyId]);
      } else if (!_isEmpty(slectedJ)) {
        setOpenedJourneys([slectedJ.journeyId]);
      }
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const hancleClick = (id) => {
    const temp = [...openedJouenys];
    if (temp.includes(id)) {
      const indexToRemove = temp.indexOf(id);
      temp.splice(indexToRemove, 1);
    } else {
      temp.push(id);
    }
    setOpenedJourneys(temp);
  };

  const handleSearch = (e) => {
    const searchKey = e.target.value;
    setSearchVal(searchKey);

    const filtered = journeys.filter((journey) => {
      const journeyTitleIncludes = journey.journeyTitle.toLowerCase().includes(searchKey.toLowerCase());
      const guidesInclude = journey.guide.some((guide) => guide.title.toLowerCase().includes(searchKey.toLowerCase()));
      return journeyTitleIncludes || guidesInclude;
    });

    if (filtered.length > 0) {
      setOpenedJourneys([filtered[0]?.journeyId]);
    } else {
      setOpenedJourneys([]);
    }
    setFilteredJourneys(filtered);
  };

  const filteredJourneysWithSelectedGuide = filteredJourneys.filter((journey) =>
    journey.guide?.some((guide) => guide.guideId === slectedGuide.guideId),
  );

  const sortedJourneys = [
    ...filteredJourneysWithSelectedGuide,
    ...filteredJourneys.filter((journey) => journey.guide?.every((guide) => guide.guideId !== slectedGuide.guideId)),
  ];

  return (
    <>
      <TextField
        placeholder="Search journey, guide"
        className={classes.searchInput}
        value={searchVal}
        onChange={handleSearch}
        InputProps={{ disableUnderline: true }}
      />
      {sortedJourneys.length > 0 ? (
        <Grid className={classes.journeyContainer}>
          {sortedJourneys?.map((journey) => (
            <Grid className={classes.jouney} key={journey.journeyId}>
              <Grid className={classes.titleBox} onClick={() => hancleClick(journey.journeyId)}>
                <Typography> {journey.journeyTitle} </Typography>
                {openedJouenys?.includes(journey.journeyId) ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </Grid>
              {openedJouenys?.includes(journey.journeyId) && (
                <Grid className={classes.guides}>
                  {journey?.guide?.map((g, i) => (
                    <Grid className={classes.guide} key={g.guideId}>
                      <Grid style={{ height: '80px', width: '13%' }}>
                        <Radio
                          onClick={() => {
                            setSelectedGuide(g);
                            setSelectedJ(journey);
                          }}
                          checked={g.guideId === slectedGuide.guideId}
                          style={{ ...(g.guideId === slectedGuide.guideId ? { color: '#622fee' } : {}) }}
                        />
                      </Grid>
                      <Grid style={{ height: '80px', width: '87%', display: 'flex' }}>
                        <Grid
                          className={classes.profilePic}
                          onClick={() => {
                            if (!_isEmpty(g.av)) {
                              const videoUrl = generateVideoUrl(g.av);
                              setGuideUrl(videoUrl);
                              setIsOpenVideoPreview(true);
                            }
                          }}
                        >
                          <Image
                            src={g.thumbnail}
                            alt="profile"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                          {!_isEmpty(g.av) ? (
                            <Grid className={classes.videoIcon}>
                              <VideoPlayIcon />
                            </Grid>
                          ) : null}
                        </Grid>
                        <Grid className={classes.content}>
                          <Typography variant="p" className={classes.title}>
                            {i + 1}. {g.title}
                          </Typography>
                          <Typography variant="p" className={classes.duration}>
                            {formatTime(g.duration)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid style={{ width: '87%', margin: '0px auto' }}>
          <ZeroState
            Icon={FileSeachIcon}
            text="No guide or journey found."
            style={{ paddingBottom: '100px' }}
            cardWidth="100%"
          />
        </Grid>
      )}

      <ThemeProvider theme={customTheme}>
        <Dialog
          open={isOpenVideoPreview}
          onClose={() => setIsOpenVideoPreview(false)}
          PaperProps={{ style: { boxShadow: 'none', borderRadius: '0px' } }}
        >
          <DialogContent style={{ padding: 0, position: 'relative' }}>
            <CustomReactPlayer
              playing
              width="600px"
              height="310"
              url={guideUrl}
              style={{ background: 'rgba(0,0,0,0.6)' }}
            />
            <Grid className={classes.closeIcon} onClick={() => setIsOpenVideoPreview(false)}>
              <CloseIcon style={{ color: '#fff' }} />
            </Grid>
          </DialogContent>
        </Dialog>
      </ThemeProvider>
    </>
  );
}
